<template>
  <Head title="Пусто" />
  <div>доступ запрещен</div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Head,
  },
}
</script>
